<template>
  <div class="tutorial-top">
    <h1>{{ content.title }}</h1>
    <div class="description-container">
      <p>{{ content.description }}</p>
      <tutorial-button
        :action="action"
        :content="content.cta"
      />
    </div>
    <img
      ref="arrowTutorial"
      class="arrow"
      :src="content.arrow"
      alt="arrow"
    >
  </div>
</template>

<script>
import mixin from './tutorialMixin'

export default {
  name: 'TutorialTop',
  mixins: [mixin]
}
</script>

<style lang="scss">
.tutorial-top {
  z-index: 9004;
  position: fixed;
  top: 52%;
  left: 15%;

  .arrow {
    position: fixed;
    transform: translateY(78%) translateX(24em);
    width: 8%;
  }

  .description-container {
    width: 60%;
  }
}
</style>
